export enum UserType {
    AGENT = "A",
    CARRIER = "R",
    CUSTOMER = "C",
    DATAFUSION = "E",
    DRIVER = "D",
    DOCK = "K",
    FACTORING_COMPANY = "5",
    FM_VENDOR = "M",
    LME = "U",
    LOCATION = "L",
    MC_CONTROL = "S",
    MCLEOD = "MCLEOD",
    PAYMENT_API = "P",
}
